// https://marmelab.com/react-admin/Authentication.html
import PermissionVoter from "./PermissionVoter";

export const roles = [
    { id: "ROLE_ADMIN", name: "ROLE_ADMIN" },
    { id: "ROLE_USER", name: "ROLE_USER" },
    { id: "ROLE_HELPING_HAND", name: "ROLE_HELPING_HAND" },
    { id: "ROLE_GUEST", name: "ROLE_GUEST" },
    { id: "ROLE_ADB", name: "ROLE_ADB" },
];

export const createAuthProvider = ({ loginUri = "/jsonlogin", storageKey = "auth", waitForConfig = false } = {}) => {
    const logout = () => {
        const request = new Request("/logout", {
            method: "GET",
            headers: new Headers({ "Accept": "application/json" }),
        });

        return fetch(request)
            .finally(() => {
                localStorage.removeItem(storageKey);
                location.hash = '#/login';
            });
    };

    return {
        login: ({ username, password }) => {
            const request = new Request(loginUri, {
                method: "POST",
                body: JSON.stringify({ username, password }),
                headers: new Headers({ "Content-Type": "application/json", "Accept": "application/json" }),
            });
            return fetch(request)
                .then(async (response) => {
                    if (response.status < 200 || response.status >= 400) {
                        const body = await response.json();
                        throw new Error(body.error);
                    }
                    return response.json();
                })
                .then((auth) => {
                    localStorage.setItem(storageKey, JSON.stringify(auth.data));
                });
        },
        checkError: async (error) => {
            const status = error.status;
            if (status === 401) {
                await logout();
                return Promise.reject();
            }
            return Promise.resolve();
        },
        checkAuth: () =>
            localStorage.getItem(storageKey) ? Promise.resolve() : Promise.reject(),
        logout: async () => {
            await logout();
        },
        getIdentity: () => {
            try {
                const { id, firstname, lastname } = JSON.parse(
                    localStorage.getItem(storageKey)
                );
                return Promise.resolve({ id, firstname, lastname });
            } catch (error) {
                return Promise.reject(error);
            }
        },
        getPermissions: () => {
            const authStr = localStorage.getItem(storageKey);
            if (authStr === null) {
                return Promise.reject("no auth");
            }
            const auth = JSON.parse(authStr);
            if (
                typeof auth === "object" &&
                auth !== null &&
                auth.hasOwnProperty("roles")
            ) {
                const roles = auth.roles;
                if (!roles) {
                    return Promise.reject("no roles");
                }

                const permissionVoter = new PermissionVoter(auth);

                if (waitForConfig) {
                    return permissionVoter.config
                        .getAsync("hiddenDesktopMenuItems")
                        .then(() => permissionVoter);
                }

                permissionVoter.config
                    .getAsync("hiddenDesktopMenuItems")
                    .catch(() => {});

                return Promise.resolve(permissionVoter);
            } else {
                return Promise.reject("not a json string");
            }
        },
    };
};

const authProvider = createAuthProvider();

export default authProvider;
